/**
 *  Load modules
 */
import common from './modules/common';
import '../scss/app.scss';
$(document).ready(function () {
  common();
});